<div class="filters-box" >
  <div class="row">
    <div class="col filter-box" *ngIf="isLoading || (data.activityDegreesStatusListFilter!=null && data.activityDegreesStatusListFilter.length > 0)">
      <app-filter-item 
        filterTitle="" 
        [filterItems]="data?.activityDegreesStatusListFilter"
        [disabled]="disabled"
        [isLoading]="isLoading"
        (setValue)="changeFilter($event,allGradesFilterType.ActivityDegreesStatusFilter)" />
    </div>

    <div class="col filter-box" *ngIf="isLoading || (data.degreesFilter!=null && data.degreesFilter.length > 0)">
      <app-filter-item 
        filterTitle="" 
        [filterItems]="data?.degreesFilter"
        [disabled]="disabled"
        [isLoading]="isLoading"
        (setValue)="changeFilter($event,allGradesFilterType.DegreesFilter)" />
    </div>

    <div class="col filter-box" *ngIf="isLoading || (data.semesterListFilter!=null && data.semesterListFilter.length > 0)">
      <app-filter-item 
        filterTitle="" 
        [filterItems]="data?.semesterListFilter"
        [disabled]="disabled"
        [isLoading]="isLoading"
        (setValue)="changeFilter($event,allGradesFilterType.SemesterListFilter)" />
    </div>

    <div class="col filter-box sorting-box" *ngIf="isLoading || (data.sortTypeListFilter!=null && data.sortTypeListFilter.length > 0)">
      <app-filter-item 
        filterTitle="" 
        [filterItems]="data?.sortTypeListFilter"
        [disabled]="disabled"
        [isLoading]="isLoading"
        (setValue)="changeFilter($event,allGradesFilterType.SortTypeListFilter)" />
    </div>
  </div>
</div>

<div class="search-box">
  <mat-form-field *ngIf="!isLoading" appearance="outline" class="mb-0">
    <input matInput [placeholder]="freeSearchPlaceholder" [disabled]="disabled" [value]="searchTerm" (input)="changeFreeSearch($event)">
    <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
  </mat-form-field>
  <app-skeleton *ngIf="isLoading" [height]="48"/>
</div>